function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M21.734 9.21C20.179 7.722 18.202 6.965 16 6.965c-3.907 0-7.213 2.638-8.393 6.183v.001c-.3.9-.47 1.861-.47 2.85 0 .989.17 1.95.47 2.85 1.18 3.545 4.486 6.184 8.393 6.184 2.018 0 3.736-.532 5.08-1.432 1.588-1.063 2.645-2.652 2.993-4.527H16v-5.802h14.127c.178.982.273 2.004.273 3.068 0 4.568-1.636 8.414-4.473 11.025C23.445 29.656 20.05 31 16 31c-5.864 0-10.937-3.361-13.405-8.264A14.994 14.994 0 0 1 1 16c0-2.42.58-4.711 1.595-6.736C5.063 4.36 10.136 1 16 1c4.043 0 7.438 1.486 10.036 3.907l-4.302 4.302z"
});

var SvgGoogle = function SvgGoogle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "#1B1F23",
    viewBox: "0 0 32 32"
  }, props), _ref);
};

export default __webpack_public_path__ + "343fd8b4d95ba95b3f632c12a7ce3b60.svg";
export { SvgGoogle as ReactComponent };


//////////////////
// WEBPACK FOOTER
// ../icons/svg/google.svg
// module id = null
// module chunks = 